import { useState } from "react";
import { Modal, Button } from "@mui/material";

const ImageEdit = ({ open, onClose, rowData, onImageUpdate }) => {
  const [preview, setPreview] = useState(rowData.image);
  const [selectedFile, setSelectedFile] = useState(null);

  // Handle file selection
  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const newImageURL = URL.createObjectURL(file);
      setPreview(newImageURL);
      setSelectedFile(file);
      rowData.image = file;
    }
  };

  return (
    <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>

      <Modal open={open} onClose={onClose}>
        <div
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            backgroundColor: "white",
            padding: "20px",
            borderRadius: "8px",
            width: "400px",
            textAlign: "center",
          }}
        >
          <h2>Edit Image</h2>

          <img
            src={preview}
            alt="Preview"
            height={100}
            width={100}
            style={{ borderRadius: "8px", marginBottom: "10px" }}
          />

          <input type="file" accept="image/*" onChange={handleFileChange} />

          <div style={{ marginTop: "10px" }}>
            <Button variant="contained" color="primary" onClick={() => onImageUpdate(rowData)}>
              Update
            </Button>
            <Button
              variant="outlined"
              color="secondary"
              onClick={onClose}
              style={{ marginLeft: "10px" }}
            >
              Cancel
            </Button>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default ImageEdit;
